import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { consts } from '@src/constants/consts';

@Component({
    selector: 'deployed-packages-filter',
    template: require('./deployed-packages-filter.component.html'),
    styles: [require('./deployed-packages-filter.component.scss')]
})
export class DeployedPackagesFilterComponent implements OnInit{

    @Output() public filter = new EventEmitter();

    public selectedFilterOption: any;
    public filterOptions: any[];

    public projectId: any;
    public environmentId: any;
    public fromDate: Date = new Date();
    public toDate: Date = new Date();
    public filterText: string = '';
    public isCustomDate: boolean = false;

    constructor(@Inject('$stateParams') stateParams: any) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;
    }

    public ngOnInit(): void {
        const arrOptions = [];
        for (const x in consts.FilterOption) {
            arrOptions.push({ key: x.replace(new RegExp('_', 'g'), ' '), value: consts.FilterOption[x] });
        }
        this.filterOptions = arrOptions;
        this.selectedFilterOption = arrOptions.find(item => item.key === 'Package Or Tag');
    }

    public selectedTime(data: any): void {
        this.fromDate = new Date(data.value.fromDate);
        this.toDate = new Date(data.value.toDate);
        this.isCustomDate = data.name === 'Custom';
    }

    public onFilter(): void {
        this.filter.emit({data: {fromDate: this.fromDate, toDate: this.toDate, filterText: this.filterText,
            filterOption: this.selectedFilterOption.value }});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/deployed-packages/deployed-packages-filter/deployed-packages-filter.component.ts